import { render, staticRenderFns } from "./NoPatologicPanel.vue?vue&type=template&id=51e2292c&"
import script from "./NoPatologicPanel.vue?vue&type=script&lang=js&"
export * from "./NoPatologicPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports